// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { withPagination } from '../traits/withPagination';
import { BaseVM } from './BaseVM';

export class PaginationVM extends withPagination(BaseVM) {}
